import React, { useContext, useState } from 'react';
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Tabs,
  Tab,
  IconButton,
  Slide,
} from '@mui/material';
import { Close, Edit as EditIcon } from '@mui/icons-material';
import AuthContext from '../../contexts/AuthContext';

import OverviewTab from './QuickTrackDataParts/OverviewTab';
import DetailsTab from './QuickTrackDataParts/DetailsTab';
import MeasurementTab from './QuickTrackDataParts/MeasurementTab';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const FullScreenQuickTrackDetails = ({
  open,
  onClose,
  teachersForStudent = [],
  behavior = {},
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const { user } = useContext(AuthContext);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const isBehaviorType =
    behavior?.info?.BehaviorDetails?.Type?.Type === 'Behavior';
  const isSkillType =
    behavior?.info?.BehaviorDetails?.Type?.Type === 'Skill Acquisition';

  const isUserApproved = () => {
    if (
      !behavior?.info?.ShareWithTeam?.EditAccess ||
      !Array.isArray(behavior.info.ShareWithTeam.EditAccess) ||
      !user?.uid
    ) {
      return false;
    }

    const userEntry = behavior.info.ShareWithTeam.EditAccess.find(
      (entry) => entry.uid === user.uid
    );
    return userEntry?.approved === true;
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar
        sx={{
          position: 'relative',
          bgcolor: '#9291ef',
          boxShadow: '0 2px 4px rgba(146, 145, 239, 0.2)',
        }}
      >
        <Toolbar>
          <IconButton
            edge='start'
            color='inherit'
            onClick={onClose}
            aria-label='close'
            sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
          >
            <Close />
          </IconButton>
          <Typography
            sx={{
              ml: 2,
              flex: 1,
              fontWeight: 700,
              letterSpacing: '0.5px',
            }}
            variant='h6'
            component='div'
          >
            QuickTrack Details
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent sx={{ p: 0, bgcolor: '#fafbfc' }}>
        <Box sx={{ height: '100%', overflow: 'auto' }}>
          <Box
            sx={{
              borderBottom: '1px solid #f0f0f0',
              px: 4,
              pt: 2,
              pb: 1,
              backgroundColor: 'white',
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label='quick track data tabs'
              centered
              sx={{
                '& .MuiTabs-indicator': {
                  backgroundColor: '#9291ef',
                  height: 3,
                  borderRadius: '2px',
                },
                '& .MuiTab-root': {
                  color: '#6c757d',
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  minHeight: 56,
                  px: 3,
                  '&:hover': {
                    color: '#9291ef',
                    backgroundColor: 'rgba(146, 145, 239, 0.04)',
                  },
                },
                '& .Mui-selected': {
                  color: '#9291ef !important',
                  fontWeight: 600,
                },
              }}
            >
              <Tab label='Overview' />
              <Tab label='Details' />
              <Tab label='Measurement' />
            </Tabs>
          </Box>

          <Box
            sx={{
              pt: 4,
              px: 4,
              pb: 6,
              backgroundColor: '#fafbfc',
              minHeight: '400px',
            }}
          >
            {activeTab === 0 && (
              <OverviewTab
                behavior={behavior}
                teachersForStudent={teachersForStudent}
                isBehaviorType={isBehaviorType}
                isSkillType={isSkillType}
                user={user}
              />
            )}

            {activeTab === 1 && <DetailsTab behavior={behavior} />}

            {activeTab === 2 && <MeasurementTab behavior={behavior} />}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default FullScreenQuickTrackDetails;
